/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import { z } from "zod/v4";

export const tenantResponseDtoSchema = z.object({
    "id": z.uuid(),
"optInAt": z.iso.datetime(),
"optOutAt": z.nullable(z.iso.datetime())
    })